module.exports = __webpack_public_path__ + "static/media/topo-anunciar-imovel.d483924b.png";